import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    background: '#FFF8F4',
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  wrapper: {
    display: 'flex',
    // height: 400,
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  imgContainer: {
    width: '100%',
    height: 400,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      height: 300,
    },
  },
  img: {
    width: '100%',
    height: '100%',
  },
  experienceBox: {
    position: 'absolute',
    paddingBlock: 12,
    paddingInline: 20,
    border: `1px solid ${theme.palette.custom.main}`,
    borderRadius: 5,
    top: '40%',
    left: -50,
    background: '#fff',
    '& .MuiTypography-root': {
      textAlign: 'center',
    },
    [theme.breakpoints.down('md')]: {
      left: -5,
    },
  },
  content: {
    paddingBlockEnd: 16,
    paddingInline: 50,
    display: 'flex',
    flexDirection: 'column !important',
    justifyContent: 'center',
    [theme.breakpoints.down('lg')]: {
      paddingInline: 40,
    },
    [theme.breakpoints.down('md')]: {
      paddingBlockStart: 0,
      paddingInline: 30,
    },
    [theme.breakpoints.down('sm')]: {
      paddingBlock: 0,
      paddingBlockStart: 16,
      paddingInlineStart: 0,
    },
  },
  title: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      color: theme.palette.custom.main,
      paddingBlockEnd: 8,
    },
  },
  description: {
    '& .MuiTypography-root': {
      textOverflow: 'ellipsis',
    },
  },
  btn: {
    paddingBlock: 12,
  },
}))

export default useStyles
